import React, { useState } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { FightingSection } from '../components/FightingSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { BlueprintDetails } from '../components/BlueprintDetails';
import { PhasesTimeline } from '../components/PhasesTimeline';
import { TransformationSection } from '../components/TransformationSection';
import { PricingSection } from '../components/PricingSection';
import { PurchasePopup } from '../components/PurchasePopup';
import { LegalModal } from '../components/LegalModal';
export function SalesPage() {
  const [legalDoc, setLegalDoc] = useState<'privacy' | 'terms' | null>(null);
  return <div className="min-h-screen bg-black text-white selection:bg-orange-500 selection:text-white" data-id="element-195">
      <UrgencyBar data-id="element-196" />
      <main data-id="element-197">
        <HeroSection data-id="element-198" />
        <FightingSection data-id="element-199" />
        <PainSection data-id="element-200" />
        <SolutionSection data-id="element-201" />
        <BlueprintDetails data-id="element-202" />
        <PhasesTimeline data-id="element-203" />
        <TransformationSection data-id="element-204" />
        <PricingSection data-id="element-205" />
      </main>

      <footer className="bg-black py-12 text-center text-gray-800 text-sm border-t border-gray-900" data-id="element-206">
        <div className="max-w-4xl mx-auto px-4" data-id="element-207">
          <p className="mb-6 max-w-2xl mx-auto" data-id="element-208">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, this site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-6" data-id="element-209">
            <button onClick={() => setLegalDoc('privacy')} className="text-gray-600 hover:text-orange-500 transition-colors underline decoration-gray-800 hover:decoration-orange-500 underline-offset-4" data-id="element-210">
              Privacy Policy
            </button>
            <button onClick={() => setLegalDoc('terms')} className="text-gray-600 hover:text-orange-500 transition-colors underline decoration-gray-800 hover:decoration-orange-500 underline-offset-4" data-id="element-211">
              Terms of Service
            </button>
          </div>

          <p data-id="element-212">
            © {new Date().getFullYear()} Feline Harmony Blueprint. All rights
            reserved.
          </p>
        </div>
      </footer>

      <PurchasePopup data-id="element-213" />
      <LegalModal isOpen={!!legalDoc} type={legalDoc} onClose={() => setLegalDoc(null)} data-id="element-214" />
    </div>;
}